import React,{ Component } from "react";
import { connect } from 'react-redux'; 
import './styles.css';

class Loading extends Component{
    constructor(props){
        super(props);
    }

     render(){
        const {isLoading}=this.props;

        return(
            (isLoading?
                <div id="loading-element">
                <div id="loading-indicator">
                <div className="lds-ripple"><div></div><div></div></div>
                </div>
                </div>    
            :null)
        )       
    }
}

const mapStateToProps = state => {
    const { AppRedux} = state
    return { 
      isLoading: AppRedux.isLoading,
     }
  }
  
  export default connect(
    mapStateToProps,
    null
  )(Loading);